import { FC, useState, useEffect } from 'react'
import clsx from 'clsx'

import ArticleTitle from 'components/articles/parts/article-title/article-title'
import YoutubeVideoFrame from 'components/webinar/video-block/video-frame'
import VideoLectorsBlock from 'components/webinar/video-block/video-block-lectors'

import { STATIC_PREVIEW_URL, currImageDomain } from 'constants/data'
import { ILectorsData, IMaterial } from 'constants/types/webinar.types'
import { getAxiosSingle } from 'pages/api/axios'
import { STATIC_URL } from 'constants/data'
import { URL_LIST } from 'constants/url'

import styles from './webinar-key-moments.module.scss'
import stylesVideo from '../../video-block/video-block.module.scss'

interface WebinarKeyMoments {
  dataset: IMaterial
  lectorsData: ILectorsData
  commentsAmmount: number
}

const WebinarKeyMoments: FC<WebinarKeyMoments> = ({ dataset, lectorsData, commentsAmmount }) => {
  const [selectedItem, setSelectedItem] = useState(0)
  const [videoData, setVideoData] = useState([{ name: '', videoLink: '', previewName: '' }])

  const currItem = videoData[selectedItem]
  useEffect(() => {
    const getVideo = async () => {
      const result = await getAxiosSingle(`${URL_LIST.FORMAT_WEBINAR_KEY_MOMENTS}/${dataset.id}`)
      if (result.status === 404) return
      setVideoData(result)
    }
    getVideo()
  }, [])

  if (!videoData) return null

  return (
    <>
      <ArticleTitle
        themes={dataset.Themes}
        title={dataset.name}
        startDate={dataset.startDate}
        showLikeShare
        comments={commentsAmmount}
      />

      <div className={styles.mainMoment}>
        <div className={stylesVideo.videoWrapper}>
          <YoutubeVideoFrame
            dataset={{
              ...dataset,
              videoLink: currItem?.videoLink.replace('https://www.youtube.com/watch?v=', ''),
            }}
            noAnalytics
          />
        </div>
        <p className={clsx(styles.momentTitle, styles.mainMomentTitle)}>{currItem?.name}</p>
      </div>
      <div className={styles.momentsWrapper}>
        {videoData[0].videoLink !== '' &&
          videoData.map((moment, index) => {
            const { name, previewName } = moment

            const isActive = selectedItem === index
            const handleMomentClick = () => setSelectedItem(index)

            return (
              <div
                className={clsx(styles.moment, {
                  [styles.momentActive]: isActive,
                })}
                onClick={handleMomentClick}
                key={name}
              >
                <div className={clsx(styles.momentPreview)}>
                  <img
                    src={
                      `${currImageDomain}${STATIC_PREVIEW_URL}/webinarMoment/${previewName}` ||
                      `${STATIC_URL}/courses/onboarding-1.png`
                    }
                    width={130}
                    height={73}
                    alt="превью"
                  />
                </div>
                <p className={clsx(styles.momentTitle)}>{name}</p>
              </div>
            )
          })}
      </div>

      <VideoLectorsBlock lectorsData={lectorsData} isEnded />
    </>
  )
}

export default WebinarKeyMoments
